import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import { Logo } from "../lib/brand";

const NAV = [
  { label: "Stays", href: "#stays" },
  { label: "Facilities", href: "#facilities" },
  { label: "About", href: "#about" },
  { label: "Payment", href: "#payment" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled ? "bg-background/90 backdrop-blur-xl border-b border-border/60 py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="container mx-auto px-6 md:px-12 max-w-7xl flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="logo-link">
          <Logo variant={scrolled ? "light" : "dark"} className="h-10 md:h-11 w-auto" testId="header-logo" />
          <span className={`hidden sm:inline font-sans text-[10px] uppercase tracking-[0.25em] border-l pl-3 transition-colors ${scrolled ? "text-foreground/80 border-border/70" : "text-white/90 border-white/30"}`}>
            Madikeri · Coorg
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className="font-sans text-sm text-foreground/80 hover:text-primary transition-colors"
            >
              {item.label}
            </a>
          ))}
          <Link to="/admin/login" data-testid="admin-link" className="font-sans text-xs text-muted-foreground/70 hover:text-primary tracking-wider uppercase">
            Admin
          </Link>
        </nav>

        <Button
          data-testid="header-book-btn"
          className="hidden md:inline-flex rounded-full bg-primary hover:bg-primary/90 text-primary-foreground px-6"
          onClick={() => document.getElementById("stays")?.scrollIntoView({ behavior: "smooth" })}
        >
          Book a Stay
        </Button>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-foreground"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-background/95 backdrop-blur-xl border-t border-border/50">
          <nav className="container mx-auto px-6 py-6 flex flex-col gap-5">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="font-sans text-base text-foreground hover:text-primary"
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              >
                {item.label}
              </a>
            ))}
            <Link to="/admin/login" className="font-sans text-sm text-muted-foreground" data-testid="mobile-admin-link">
              Admin Login
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
